import { defineMessages } from 'react-intl';

const messages = defineMessages({
  forYou: {
    defaultMessage: 'For you',
    description: 'Navigation link to Explore\'s "For you" page'
  },
  feed: {
    defaultMessage: 'Explore',
    description: 'Navigation link to Explore\'s "Feed" page'
  },
  following: {
    defaultMessage: 'Following',
    description: 'Navigation link to Explore\'s "Following" page'
  }
});

export default messages;
